/* eslint-disable */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { MAIN_ICON_COLORS } from 'assets/components';
import { FLOWS, sendStats } from '../../../../services/mixpanel';
import { MXP_ONBOARDING_SIGN_UP_CREATE_ACCOUNT } from '../../../../screens/Onboarding/mixpanel-events';
import { PromoLogo } from '../PromoLogo';
import { dynamicAssets } from '../../../../utilities/helpers';
import { PromoGridLayout } from '../PromoGridLayout';
import { Typography } from '../../../../components';
import PropTypes from 'prop-types';
import Icon from '../../../../components/Icon';
import { ICONS } from '../../../../components/Icon/constants';
import { getCurrentLanguage, switchLanguage } from '../../../../i18n';
import { Tooltip } from 'react-tooltip';
import { useUsEnv } from '../../../../utilities/sharedHooks/useUsEnv';

export const PromoMobileContent = ({isUSA}) => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  const tooltipRef = useRef(null);
  const langBtnRef = useRef(null);

  const [showLanguageSelector, setShowLanguageSelector] = useState(false);

  const [selectedLang, setSelectedLang] = useState('en');

  const { isUsEnv } = useUsEnv();

  useEffect(() => {
    const currentLang = getCurrentLanguage();
    setSelectedLang(currentLang);
  }, []);

  const availableLangs = useMemo(
    () => [
      {
        value: 'en',
        label: 'lang_name_en',
      },
      {
        value: 'de',
        label: 'lang_name_de',
      },
    ],
    []
  );

  const handleClickOutside = (e) => {
    if ((!tooltipRef.current || (tooltipRef.current && !tooltipRef.current.contains(e.target))) && langBtnRef.current && !langBtnRef.current.contains(e.target)) {
      setShowLanguageSelector(false);
      document.removeEventListener('click', handleClickOutside);
    }
  };

  useEffect(() => () => document.removeEventListener('click', handleClickOutside), []);

  const handleOpenLanguageSelector = () => {
    setShowLanguageSelector((prev) => !prev);
    document.addEventListener('click', handleClickOutside);
  };


  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const imagesStyle = useMemo(() => {
    const result = {
      topCardContainer: {
        left: 0,
      },
      bottomCardContainer: {
        left: -10
      },
      mainCardContainer: {
        justifyContent: 'end',
      }
    }
    if (screenWidth >= 540) {
      result.topCardContainer.left = 90;
      result.bottomCardContainer.left= 90;
      result.mainCardContainer.justifyContent = 'center';
      result.mainCardContainer.paddingLeft = 40;
    };
    return result;
  }, [screenWidth])


  return (
    <div className="position-relative" style={{ flex: 1, paddingBottom: '5rem' }}>
      <div className="position-sticky top-0 left-0 mobile-header px-4 pt-2 flex-row justify-content-between d-flex w-100">
        <PromoLogo />
        <div className="d-flex justify-content-end align-items-center" style={{ gap: '0.5rem'}}>
          <button
            onClick={() => history.push('/onboarding/login')}
            className="btn-primary-outline d-flex align-items-center px-2"
            style={{ height: '40px' }}
            type="button">
            {translate('login_form_button_label')}
          </button>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <button
            ref={langBtnRef}
            data-tooltip-id="language-selector"
            type="button"
            className="btn-primary-outline px-2"
            style={{ width: '40px', height: '40px', outline: 'none' }}
            onClick={() => {
              handleOpenLanguageSelector();
            }}>
            <Icon icon={ICONS.GLOBE_LANG} color={MAIN_ICON_COLORS.WHITE} />
          </button>
        </div>
      </div>
      <div
        className="d-flex flex-column w-100 position-relative"
        style={{ marginTop: '41px', minHeight: '350px' }}>
        <div style={{ position: 'absolute', top: -100, right: 60 }}>
          <img
            width={500}
            alt="clipboard"
            src={dynamicAssets('./assets/images/promo-gradient.png')}
          />
        </div>
        <div style={{ position: 'absolute', top: -80, left: imagesStyle.topCardContainer.left }}>
          <img
            width={300}
            alt="clipboard"
            src={dynamicAssets(isUSA ? './assets/images/promo-us-image-1.png' : './assets/images/promo-image-1.png')}
          />
        </div>
        <div style={{ position: 'absolute', bottom: -30, left: imagesStyle.bottomCardContainer.left }}>
          <img
            width={300}
            alt="clipboard"
            src={dynamicAssets(isUSA ? './assets/images/promo-us-image-2.png' : './assets/images/promo-image-2.png')}
          />
        </div>
        <PromoGridLayout />
        <div className="d-flex align-items-center pe-3" style={{ zIndex: 10, ...imagesStyle.mainCardContainer }}>
          <img
            width={300}
            alt="clipboard"
            src={
              isUSA
                ? dynamicAssets('./assets/images/promo-us-image-3.png')
                : dynamicAssets('./assets/images/promo-image-3.png')
            }
          />
        </div>
      </div>
      <div
        className="bg-light position-relative"
        style={{ borderTopLeftRadius: 24, borderTopRightRadius: 24, zIndex: 10 }}>
        <div className="d-flex flex-column p-3" style={{ gap: '32px'}}>
          <div className="d-flex flex-column gap-3">
            <div className="d-flex flex-column">
              <Typography as="h1" className="main-title-text w-100 m-0">
                {translate('promo_title_browser_1')}
              </Typography>
              <Typography as="h1" className="main-title-text w-100 m-0">
                <Trans
                  i18nKey="promo_title_browser_2"
                  components={[<span className="masked-text" />]}
                />
              </Typography>
            </div>
            <div className="d-flex flex-column gap-4">
              <p className="text-white" style={{ fontFamily: 'Test Sohne', fontSize: '14px' }}>{translate('promo_title_body_mobile_1')}</p>
              <p className="text-white" style={{ fontFamily: 'Test Sohne', fontSize: '14px' }}>{isUSA ? translate('promo_title_body_mobile_us_2') :translate('promo_title_body_mobile_2')}</p>
            </div>
          </div>
          <div className="d-flex flex-wrap" style={{ gap: '20px'}}>
            <div className="d-flex flex-column gap-2" style={{ flex: 1 }}>
              <p
                className="text-white"
                style={{
                  whiteSpace: 'pre-line',
                  fontFamily: 'Monument Extended',
                  fontSize: '18px',
                }}>
                {translate('promo_body1').replace(' ', '\n')}
              </p>
              <div style={{ opacity: 0.6, maxWidth: '170px' }}>
                <Typography as="p" variant="small" className="text-white" style={{ fontFamily: 'Test Sohne' }}>
                  {translate('promo_subtitle1')}
                </Typography>
              </div>
            </div>
            <div className=" d-flex flex-column gap-2" style={{ flex: 1 }}>
              <p
                className="text-white"
                style={{
                  whiteSpace: 'pre-line',
                  fontFamily: 'Monument Extended',
                  fontSize: '18px',
                }}>
                {translate(isUsEnv ? 'promo_us_body2' : 'promo_body2').replace(' ', '\n')}
              </p>
              <div style={{ opacity: 0.6, maxWidth: '180px' }}>
                <Typography as="p" variant="small" className="text-white" style={{ fontFamily: 'Test Sohne' }}>
                  {isUSA ? translate('promo_subtitle2_us_1') :translate('promo_subtitle2_1')}
                </Typography>
                <Typography as="p" variant="small" className="text-white" style={{ fontFamily: 'Test Sohne' }}>
                  {translate('promo_subtitle2_2')}
                </Typography>
              </div>
            </div>
            <div className=" d-flex flex-column gap-2">
              <div className="d-flex flex-column">
                <p
                  className="text-white"
                  style={{
                    whiteSpace: 'pre-line',
                    fontFamily: 'Monument Extended',
                    fontSize: '18px',
                  }}>
                  0%
                </p>
                <p
                  className="text-white"
                  style={{
                    whiteSpace: 'pre-line',
                    fontFamily: 'Monument Extended',
                    fontSize: '18px',
                  }}>
                  {translate('promo_body3')}
                </p>
              </div>
              <div style={{ opacity: 0.6, maxWidth: '180px' }}>
                <Typography as="p" variant="small" className="text-white" style={{ fontFamily: 'Test Sohne' }}>
                  {isUSA ? translate('promo_us_subtitle3') :translate('promo_subtitle3')}
                </Typography>
              </div>
            </div>
          </div>
          <div
            className="d-flex flex-column"
            style={{ gap: '16px' }}>
            <Typography
              as="p"
              variant="base"
              className="text-white"
              style={{ fontFamily: 'Test Sohne' }}>
              {translate('promo_lunching_soon')}
            </Typography>
            <div className="d-flex flex-wrap" style={{ gap: '20px' }}>
              <div className="d-flex align-items-center">
                <div
                  className="me-2 d-flex justify-content-center align-items-center"
                  style={{ width: '12px', height: '9px' }}>
                  <Icon icon={ICONS.CHECK} color={MAIN_ICON_COLORS.PRIMARY} />
                </div>
                <Typography
                  as="p"
                  variant="small"
                  className="text-white"
                  style={{ opacity: 0.6, fontFamily: 'Test Sohne' }}>
                  {translate('promo_lunching_feature_1')}
                </Typography>
              </div>
              <div className="d-flex align-items-center">
                <div
                  className="me-2 d-flex justify-content-center align-items-center"
                  style={{ width: '12px', height: '9px' }}>
                  <Icon icon={ICONS.CHECK} color={MAIN_ICON_COLORS.PRIMARY} />
                </div>
                <Typography
                  as="p"
                  variant="small"
                  className="text-white"
                  style={{ opacity: 0.6, fontFamily: 'Test Sohne' }}>
                  {translate('promo_lunching_feature_2')}
                </Typography>
              </div>
              {isUSA && (
                <div className="d-flex align-items-center">
                  <div
                    className="me-2 d-flex justify-content-center align-items-center"
                    style={{ width: '12px', height: '9px' }}>
                    <Icon icon={ICONS.CHECK} color={MAIN_ICON_COLORS.PRIMARY} />
                  </div>
                  <Typography
                    as="p"
                    variant="small"
                    className="text-white"
                    style={{ opacity: 0.6, fontFamily: 'Test Sohne' }}>
                    {translate('promo_lunching_feature_us_3')}
                  </Typography>
                </div>
              )}
            </div>
          </div>
          <div className="d-flex flex-column w-100 h-100 gap-4 py-4" style={{ opacity: 0.46 }}>
            <div className="d-flex flex-column w-100">
              <Typography as="p" variant="small" className="text-white">
                {isUSA ? translate('promo_disclosure_us_1_1') :translate('promo_disclosure_1_1')}
              </Typography>
              <Typography as="p" variant="small" className="text-white">
                {translate('promo_disclosure_1_2')}
              </Typography>
            </div>
            <Typography as="p" variant="small" className="text-white">
              {translate('promo_disclosure_2')}
            </Typography>
            <Typography as="p" variant="small" className="text-white">
              {translate('promo_disclosure_3')}
            </Typography>
          </div>
        </div>
      </div>
      <div
        style={{ zIndex: 30 }}
        className="position-fixed bottom-0 w-100 d-flex flex-row align-items-center justify-content-start pt-3">
        <div className="bg-light w-100 px-3 py-3">
          <button
            onClick={() => {
              sendStats(MXP_ONBOARDING_SIGN_UP_CREATE_ACCOUNT, {}, FLOWS.ONBOARDING);
              history.push('/onboarding/signup');
            }}
            style={{ fontFamily: 'Inter', fontWeight: 'bold'}}
            className="btn btn-block btn-primary w-100 text-f5 d-flex align-items-center justify-content-center gap-4"
            type="button">
            {translate('promo_button1_label')}
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: '16px', height: '16px' }}>
              <Icon icon={ICONS.RIGHT_ARROW} color={MAIN_ICON_COLORS.WHITE} />
            </div>
          </button>
        </div>
      </div>
      <Tooltip
        id="language-selector"
        isOpen={showLanguageSelector}
        place="bottom"
        variant="dark"
        opacity={1}
        style={{ zIndex: 100, padding: '0px', pointerEvents: 'auto' }}
        className="rounded border-1">
        <ul className="d-flex flex-column list-unstyled m-0">
          {availableLangs.map((lang) => (
            <li
              role="presentation"
              tabIndex={-1}
              onKeyDown={null}
              onClick={() => {
                setSelectedLang(lang.value);
                switchLanguage(lang.value);
                setShowLanguageSelector(false);
              }}
              className={`cursor-pointer px-5 py-2 ${
                selectedLang === lang.value ? 'text-primary' : 'text-hover'
              }`}
              key={lang.value}>
              {translate(lang.label)}
            </li>
          ))}
        </ul>
      </Tooltip>
    </div>
  );
};

PromoMobileContent.propTypes = {
  isUSA: PropTypes.bool,
};
PromoMobileContent.defaultProps = {
  isUSA: false,
};
